import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '60px auto', padding: '0 24px', fontFamily: 'Arial, sans-serif', color: '#333', lineHeight: '1.7' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
        <img src="/absloute-logo.jpeg" alt="AbsoluteVision Logo" style={{ width: '50px', height: '50px', objectFit: 'contain', borderRadius: '8px' }} />
        <span style={{ fontSize: '20px', fontWeight: '600', color: '#1e3a8a' }}>Absolute Vision</span>
      </div>
      <h1 style={{ fontSize: '28px', marginBottom: '16px' }}>Privacy Policy</h1>
      <p style={{ marginBottom: '24px' }}>
        This Privacy Policy describes how Absolute Vision collects, uses, and protects user data.
      </p>

      <h2 style={{ fontSize: '18px', marginTop: '24px' }}>1. Information We Collect</h2>
      <p>
        We may collect personal information such as name, email address, student details, attendance records, and usage data.
      </p>

      <h2 style={{ fontSize: '18px', marginTop: '24px' }}>2. How We Use Information</h2>
      <p>
        We use the collected data to provide and improve our services, manage academic records, track attendance, and communicate with users.
      </p>

      <h2 style={{ fontSize: '18px', marginTop: '24px' }}>3. Data Sharing</h2>
      <p>
        We do not sell user data. Data may be processed using trusted third-party services such as AWS and Firebase for backend and notifications.
      </p>

      <h2 style={{ fontSize: '18px', marginTop: '24px' }}>4. Data Security</h2>
      <p>
        We take appropriate security measures to protect user data from unauthorized access.
      </p>

      <h2 style={{ fontSize: '18px', marginTop: '24px' }}>5. User Rights</h2>
      <p>
        Users can request access, correction, or deletion of their data by contacting us.
      </p>

      <h2 style={{ fontSize: '18px', marginTop: '24px' }}>6. Contact Us</h2>
      <p>
        If you have any questions, contact us at:{' '}
        <a href="mailto:admin@astravision.net" style={{ color: '#1a73e8' }}>admin@astravision.net</a>
      </p>

      <div style={{ marginTop: '40px' }}>
        <a href="/school-management" style={{ color: '#1a73e8', textDecoration: 'none', fontSize: '14px' }}>← Back to School Management</a>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
